import { useMutation } from "@apollo/client";
import { gql } from "@/gql";

const REGISTER_AND_ACCEPT_INVITATION_MUTATION = gql(`
  mutation RegisterAndAcceptInvitation($input: RegisterWithInvitationInput!) {
    registerAndAcceptInvitation(input: $input) {
      accessToken
      refreshToken
      userId
      workerId
    }
  }
`);

export const useRegisterWithInvitation = () => {
  const [registerMutation, { loading, error }] = useMutation(
    REGISTER_AND_ACCEPT_INVITATION_MUTATION
  );

  const registerWithInvitation = async (input: {
    token: string;
    email: string;
    password: string;
    firstName: string;
    lastName: string;
  }) => {
    const result = await registerMutation({
      variables: { input },
    });
    return result.data?.registerAndAcceptInvitation;
  };

  return {
    registerWithInvitation,
    loading,
    error,
  };
};
